module.exports = __webpack_public_path__ + "static/media/illustration-thank-you.cb8e07d4.svg";